import { Link } from 'react-router-dom';

export default function BackArrow() {
    return(
        <Link to='/super-admin/containers-parking'><div className='back-arrow'></div></Link>
    )
}